import axios from "axios";
import { getAccessToken } from "./auth";

// Single axios instance for the whole app. baseURL + auth token are built once
// here instead of being duplicated (and hardcoded) in every component.
const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VER}`,
  headers: {
    "Request-Token": process.env.VUE_APP_SEC_HEADER,
  },
});

//HTTP Interceptor to Attach Bearer Token
api.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Re-exported so components can keep importing it from "../services/api".
// The implementation lives in its own import-free module — see the note there.
export { apiErrorMessage, responseErrorMessage } from "./apiErrorMessage";

export default api;
